(function () {
  if (window.__molicAlcoholGate) return;
  window.__molicAlcoholGate = true;

  var KEY = 'molic_age_ok';
  function isOk() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setOk(v) { try { if (v) sessionStorage.setItem(KEY, '1'); else sessionStorage.removeItem(KEY); } catch (e) {} }

  function sync() {
    var boxes = document.querySelectorAll('.alcohol-age-check__input');
    var ok = isOk();
    boxes.forEach(function (b) { b.checked = ok; });
    document.documentElement.classList.toggle('alcohol-gate-locked', boxes.length > 0 && !ok);
  }

  function insertProductNotice() {
    var tpl = document.getElementById('alcohol-product-notice');
    if (!tpl || document.querySelector('.alcohol-product-notice')) return;
    var target = document.querySelector('product-form') || document.querySelector('.product-form');
    if (target && target.parentNode) {
      target.parentNode.insertBefore(tpl.content.cloneNode(true), target);
    }
  }

  // Casilla que pertenece al mismo formulario que el botón pulsado (panel lateral o página del carrito).
  function boxFor(btn) {
    var all = Array.prototype.slice.call(document.querySelectorAll('.alcohol-age-check__input'));
    var formId = btn && btn.getAttribute && btn.getAttribute('form');
    if (!formId && btn && btn.form) formId = btn.form.id;
    var same = all.filter(function (b) { return formId && b.getAttribute('form') === formId; });
    if (same.length) return same[0];
    var inDrawer = btn && btn.closest && btn.closest('cart-drawer');
    var scoped = all.filter(function (b) { return !!b.closest('cart-drawer') === !!inDrawer; });
    var visible = scoped.filter(function (b) { return b.offsetParent !== null; });
    return visible[0] || scoped[0] || all[0] || null;
  }

  function block(e, btn) {
    var box = boxFor(btn);
    if (!box || isOk()) return false;
    e.preventDefault();
    e.stopImmediatePropagation();
    var wrap = box.closest('.alcohol-age-check');
    if (wrap) {
      wrap.classList.add('is-invalid');
      if (wrap.scrollIntoView) wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
    box.focus();
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart__checkout-button, [name="checkout"]');
    if (btn) block(e, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (s && s.name === 'checkout') block(e, s);
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('alcohol-age-check__input')) {
      setOk(e.target.checked);
      document.querySelectorAll('.alcohol-age-check').forEach(function (w) { w.classList.remove('is-invalid'); });
      sync();
    }
  });

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; sync(); insertProductNotice(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () { sync(); insertProductNotice(); });
  sync();
})();
